export default __webpack_public_path__ + "static/media/pause_button.dd1a73ce.png";